/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { ServiceObjectCreateV1Dto } from '../models/ServiceObjectCreateV1Dto';
import type { ServiceObjectPatchV1Dto } from '../models/ServiceObjectPatchV1Dto';
import type { ServiceObjectV1Dto } from '../models/ServiceObjectV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectsService {
  /**
   * @param requestBody
   * @returns ServiceObjectV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectControllerV1CreateV1(
    requestBody: ServiceObjectCreateV1Dto,
  ): CancelablePromise<ServiceObjectV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static serviceObjectControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ServiceObjectV1Dto a entity list
   * @throws ApiError
   */
  public static serviceObjectControllerV1FindAllV1(): CancelablePromise<Array<ServiceObjectV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid objectId
   * @returns ServiceObjectV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ServiceObjectV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid objectId
   * @returns ServiceObjectV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ServiceObjectV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid objectId
   * @param requestBody Service object fields to update
   * @returns ServiceObjectV1Dto the update entity
   * @throws ApiError
   */
  public static serviceObjectControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: ServiceObjectPatchV1Dto,
  ): CancelablePromise<ServiceObjectV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/service-objects/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
